import { useMediaQuery } from '@mui/material';
import { useCallback } from 'react';

import type { UseDetectionReturnValue } from './useDetection.types';

export const useDetection = (): UseDetectionReturnValue => {
  const isMobile = useMediaQuery('(pointer:coarse), (hover:none)');

  const isBrowserSafari = useCallback(
    (userAgent: string) => /^((?!chrome|android).)*safari/i.test(userAgent),
    []
  );

  const isIOS = useCallback(
    (userAgent: string) => /iPhone|iPod|iPad/i.test(userAgent),
    []
  );

  const isIOSChrome = useCallback(
    (userAgent: string) => isIOS(userAgent) && /CriOS/i.test(userAgent),
    [isIOS]
  );

  return {
    isBrowserSafari,
    isIOS,
    isIOSChrome,
    isMobile,
  };
};
